import styled from "styled-components";

export const SFooter = styled.footer`
    height: 4rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.theme.colors.background};
    p{
        color:  ${props => props.theme.colors.white};
        padding: 0 2rem;
        text-align: center;
        font-size: 1rem;
    }

`